import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const getAverageScore = async () => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/probability/score`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Score error:", error);
    throw error;
  }
};

export { getAverageScore };
